/* global wc_single_product_params wooatm FirstChildExpand */

import { simulateSimilarClick, triggerEvent } from './functions';


const testbuildScrollContainers = () => {
  // Find all scroll containers (usually the MCB products module)
  Array.from(document.getElementsByClassName('color-selector-scroll')).forEach((container) => {
    const currentElement = container;
    const parentWrapper = container.parentNode;
    const safeSpace = 25;
    const nextButton = document.createElement('button');
    const prevButton = document.createElement('button');

    prevButton.className = 'navigation-button nude prev-product';
    nextButton.className = 'navigation-button nude next-product';

    prevButton.addEventListener('click', (event) => {
      event.preventDefault();
      const listItem = currentElement.querySelector('.variant-switcher');

      const start = currentElement.scrollLeft;
      const difference = -listItem.offsetWidth * 2;
      const increment = 5;
      const duration = 300;
      let currentTime = 0;

      const animateScroll = () => {
        currentTime += increment;
        currentElement.scrollLeft = Math.easeInOutQuad(currentTime, start, difference, duration);

        if (currentTime < duration) {
          setTimeout(animateScroll, increment);
        }
      };

      animateScroll();
    });

    nextButton.addEventListener('click', (event) => {
      event.preventDefault();

      const listItem = currentElement.querySelector('.variant-switcher');
      const start = currentElement.scrollLeft;
      const difference = listItem.offsetWidth * 2;
      const increment = 5;
      const duration = 300;
      let currentTime = 0;

      const animateScroll = () => {
        currentTime += increment;
        currentElement.scrollLeft = Math.easeInOutQuad(currentTime, start, difference, duration);

        if (currentTime < duration) {
          setTimeout(animateScroll, increment);
        }
      };

      animateScroll();
    });

    parentWrapper.classList.add('scroll-container-parent-wrapper');
    parentWrapper.style.position = 'relative';
    parentWrapper.appendChild(prevButton);
    parentWrapper.appendChild(nextButton);

    const checkIfScroll = () => {
      // Check if the div have a scroll, if not: add a class
      if (container.scrollWidth === container.clientWidth) {
        parentWrapper.classList.add('this-is-not-the-scroll-you-are-looking-for');
      } else {
        parentWrapper.classList.remove('this-is-not-the-scroll-you-are-looking-for');
      }
    };

    checkIfScroll();
    window.addEventListener('resize', () => checkIfScroll());
    document.body.addEventListener('variable-product-filter-changed', checkIfScroll);

    // This is fixing a timing issue with the MCB product ajax fetcher and the scroll check
    jQuery(document.body).on('mcb-product-fetched', () => {
      checkIfScroll();

      setTimeout(() => {
        checkIfScroll();
      }, 200);
    });

    // When a user is scrolling inside of the module, add includes to start and end based on scroll position
    container.addEventListener('scroll', () => {
      const scrollLength = container.scrollLeft + container.clientWidth + safeSpace;

      // Adds a class when the scroller is getting close to the end
      if (scrollLength > container.scrollWidth) {
        parentWrapper.classList.add('scroll-close-to-end');
      } else {
        parentWrapper.classList.remove('scroll-close-to-end');
      }

      // Adds a class when the scroller have scrolled a bit away from the start
      if (container.scrollLeft > safeSpace) {
        parentWrapper.classList.add('scroll-away-from-start');
      } else {
        parentWrapper.classList.remove('scroll-away-from-start');
      }
    });
  });
};
testbuildScrollContainers();

const maksimerVariableProduct = () => {
  let activeFilter = document.querySelector('.color-group-selector.active');

  const buttons = (multiple = true) => {
    let switchers = Array.from(document.querySelectorAll('.variant-switcher'));

    if (multiple) {
      const panelSwitcher = Array.from(document.querySelectorAll('.pick-color-list button'));
      switchers = switchers.concat(panelSwitcher);
    }

    return switchers;
  };

  const variants = [];

  const initOtherJsStuffOnChange = () => {
    // eslint-disable-next-line func-names
    jQuery('.woocommerce-product-gallery').each(function () {
      // eslint-disable-next-line camelcase
      jQuery(this).trigger('wc-product-gallery-before-init', [this, wc_single_product_params]);
      // eslint-disable-next-line camelcase
      jQuery(this).wc_product_gallery(wc_single_product_params);
      // eslint-disable-next-line camelcase
      jQuery(this).trigger('wc-product-gallery-after-init', [this, wc_single_product_params]);
    });

    const FirstChildExpand = wooatm.first_child_expand === 'yes';
    const MultipleExpand = wooatm.multiple_expand === 'yes';
    jQuery('#accordion-container').accordion({
      firstChildExpand: FirstChildExpand,
      slideSpeed: 500,
      dropDownIcon: '&#9660',
      multiExpand: MultipleExpand,
    });

    jQuery('a.woocommerce-review-link').click((e) => {
      e.preventDefault();
      if (jQuery('#tab-reviews').is(':hidden')) jQuery('.reviews_tab').click();
      jQuery('html, body').animate({
        scrollTop: jQuery('#tab-reviews').offset().top - 40,
      }, 1000);
      return true;
    });

    const { hash } = window.location;
    const url = window.location.href;
    if (hash.toLowerCase().indexOf('comment-') >= 0 || hash === '#reviews') {
      jQuery('li.reviews_tab').click();
    } else if (url.indexOf('comment-page-') > 0 || url.indexOf('cpage=') > 0) {
      jQuery('li.reviews_tab').click();
    }

    triggerEvent(document.body, 'variable-product-changed-product');

    // eslint-disable-next-line no-undef
    wcwl_apply_event_on_page_update();
    setTimeout(() => {
    }, 100);
  };

  const colorGroupFiltering = () => {
    const activeButton = document.querySelector('.color-selector-dropdown-active');
    const dropdown = document.querySelector('ul.color-selector-dropdown');

    if (activeButton) {
      activeButton.addEventListener('click', (event) => {
        event.preventDefault();

        activeButton.classList.toggle('open');
        dropdown.classList.toggle('hidden');
      });
    }

    const filterButtons = Array.from(document.querySelectorAll('button.color-group-selector'));

    if (filterButtons) {
      filterButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();

          const { group } = button.dataset;

          const colorOptions = Array.from(document.querySelectorAll('.color-group-item'));

          if (colorOptions) {
            colorOptions.forEach((colorOption) => {
              if (group === 'alle') {
                colorOption.classList.remove('hidden');
              } else {
                colorOption.classList.add('hidden');

                if (colorOption.classList.contains(`group-${group}`)) {
                  colorOption.classList.remove('hidden');
                }
              }
            });
          }

          const variantStillActive = document.querySelector('.color-group-item.selected:not(.hidden)');

          if (!variantStillActive) {
            const firstActive = document.querySelector('.color-group-item:not(.hidden)');
            firstActive.click();
          }

          const currentActive = document.querySelector('button.color-group-selector.active');

          if (currentActive) {
            currentActive.classList.remove('active');
          }

          const btn = document.querySelector(`.color-group-selector.${group}`);
          btn.classList.add('active');

          const colorOptionsf = Array.from(document.querySelectorAll('.color-group-item'));

          if (colorOptionsf) {
            colorOptionsf.forEach((colorOption) => {
              if (group === 'alle') {
                colorOption.classList.remove('hidden');
              } else {
                colorOption.classList.add('hidden');

                if (colorOption.classList.contains(`group-${group}`)) {
                  colorOption.classList.remove('hidden');
                }
              }
            });
          }

          triggerEvent(document.body, 'variable-product-filter-changed');

          // if (prevSelected) {
          //   setTimeout(() => {
          //     const act = document.querySelector('.color-group-item:not(.hidden)');
          //     const btn = document.querySelector(`.color-group-selector.${act.dataset.group}`);
          //     btn.classList.add('active');
          //   }, 20);
          //   prevSelected.click();
          // }
        });
      });
    }
  };

  const initCheckScrollContainer = () => {
    const selector = document.querySelector('.color-selector-scroll');
    if (selector) {
      const selected = selector.querySelector('.variant-switcher.selected');
      if (selected) {
        selector.scrollLeft = selected.offsetLeft - selected.offsetWidth;
      }
    }
  };

  const stickyColorSwitcher = () => {
    const container = document.querySelector('.dropdown-color-switcher');

    if (!container) {
      return;
    }

    const panel = container.querySelector('.pick-color-list');
    const togglePanelButton = container.querySelector('button.color-info');

    togglePanelButton.addEventListener('click', (event) => {
      event.preventDefault();
      panel.classList.toggle('hidden');
    });
  };

  const addClickEvents = () => {
    if (buttons()) {
      const { postId } = document.body.dataset;
      buttons().forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          const { id, href } = button.dataset;

          if (postId === id) {
            return;
          }

          const selector = document.querySelector('.color-selector-scroll');
          const currentScroll = selector.scrollLeft;

          activeFilter = document.querySelector('.color-group-selector.active');

          document.body.dataset.postId = id;

          const variant = variants.find((qdq) => qdq.id === id);
          window.history.pushState('', '', href);

          const salesBanner = document.querySelector('#main-content .image-and-entry-summary .sales-banner');
          const images = document.querySelector('#main-content .image-and-entry-summary .image-gallery-wrapper .image-gallery-container');
          const summary = document.querySelector('#main-content .image-and-entry-summary .summary.entry-summary');
          const productHeader = document.querySelector('#main-content .product-header');
          const productTip = document.querySelector('#main-content .product-tips-wrapper');

          if (images) {
            images.innerHTML = variant.content.querySelector('#main-content .image-and-entry-summary .image-gallery-wrapper .image-gallery-container').innerHTML;
          } else {
            const imagesSlider = document.querySelector('#main-content .image-and-entry-summary .product-image-slider');
            imagesSlider.innerHTML = variant.content.querySelector('#main-content .image-and-entry-summary .product-image-slider').innerHTML;

            const buildProductImageSlideNumberIndicator = () => {
              const wrapper = document.querySelector('.product-image-slider');
              if (wrapper) {
                const slides = Array.from(wrapper.querySelectorAll('.woocommerce-product-gallery__image'));
                if (slides) {
                  wrapper.classList.add(`slides-${slides.length}`);

                  let counter = 1;
                  slides.forEach((slide) => {
                    const slideIndicator = document.createElement('span');
                    slideIndicator.className = 'slide-indicator';
                    slideIndicator.innerText = `${counter}/${slides.length}`;
                    slide.appendChild(slideIndicator);

                    counter += 1;
                  });
                }
              }
            };
            buildProductImageSlideNumberIndicator();
          }
          summary.innerHTML = variant.content.querySelector('#main-content .image-and-entry-summary .summary.entry-summary').innerHTML;
          productHeader.innerHTML = variant.content.querySelector('#main-content .product-header').innerHTML;

          productTip.innerHTML = variant.content.querySelector('#main-content .product-tips-wrapper').innerHTML;

          if (salesBanner) {
            const newSalesBanner = variant.content.querySelector('#main-content .image-and-entry-summary .sales-banner');
            if (newSalesBanner) {
              salesBanner.innerHTML = newSalesBanner.innerHTML;
              salesBanner.className = newSalesBanner.className;
            }
          } else {
            const newSalesBanner = variant.content.querySelector('#main-content .image-and-entry-summary .sales-banner');
            if (newSalesBanner) {
              document.querySelector('#main-content .image-and-entry-summary').appendChild(newSalesBanner);
            }
          }

          activeFilter.click();

          document.querySelector('.color-selector-scroll').scrollLeft = currentScroll;

          setTimeout(() => {
            initOtherJsStuffOnChange();


            if (window.Revieve) {
              window.Revieve.API.liveAR.addTryOnProduct(id);
              console.log(id);
            }
          }, 10);
          testbuildScrollContainers();
          colorGroupFiltering();
          addClickEvents();
          stickyColorSwitcher();
        });
      });
    }
  };

  const buildVariableDataset = () => {
    const btns = buttons(false);

    if (!btns) {
      return;
    }

    btns.forEach((button) => {
      const { id, href } = button.dataset;

      button.classList.add('loading');

      const product = {
        id,
        content: '',
      };

      jQuery.get(href, (res) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(res, 'text/html');
        product.content = doc.querySelector('html');

        button.classList.remove('loading');

        variants.push(product);
      });
    });
  };
  setTimeout(() => {
    buildVariableDataset();
  }, 10);


  const initReviews = () => {
    const chooseVariation = document.querySelector('#commentform select[name=choose_child]');
    if (chooseVariation) {
      const submitButtonPre = document.querySelector('#commentform .form-submit .submit');
      submitButtonPre.disabled = true;

      chooseVariation.addEventListener('change', () => {
        const commentPostId = document.querySelector('#commentform #comment_post_ID');
        commentPostId.value = chooseVariation.options[chooseVariation.selectedIndex].value;
        const submitButton = document.querySelector('#commentform .form-submit .submit');
        submitButton.disabled = false;
      });
    }
  };
  initReviews();


  initCheckScrollContainer();
  colorGroupFiltering();
  stickyColorSwitcher();
  addClickEvents();
};

if (document.body.classList.contains('single-product')) {
  maksimerVariableProduct();
}

const maksimerVariableProductLoop = () => {
  const productLoopItems = Array.from(document.querySelectorAll('ul.products li.product-type-variable-mother'));

  if (productLoopItems) {
    productLoopItems.forEach((listItem) => {
      const colorOptions = Array.from(listItem.querySelectorAll('.product-list-item'));
      const colorButtons = Array.from(listItem.querySelectorAll('.children-switcher'));

      colorButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();

          colorOptions.forEach((option) => {
            option.classList.add('hidden');
          });

          listItem.querySelector('.children-switcher.selected').classList.remove('selected');
          button.classList.add('selected');

          const { id } = button.dataset;

          const chosen = listItem.querySelector(`#product-id-${id}`);
          chosen.classList.remove('hidden');
        });
      });
    });
  }
};

maksimerVariableProductLoop();
document.body.addEventListener('load-more-triggered', maksimerVariableProductLoop);
document.body.addEventListener('search-result-updated', maksimerVariableProductLoop);
jQuery(document.body).on('mcb-product-fetched', maksimerVariableProductLoop);
